export const products = [
  {
    id: 1,
    name: 'Sofa Chair',
    basePrice: 599,
    description: 'Comfortable sofa chair with modern design',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400',
    modelPath: '/models/sofa_chair.glb'
  },
  {
    id: 2,
    name: '3-Cushion Couch',
    basePrice: 899,
    description: 'Spacious couch with three comfortable cushions',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400',
    modelPath: '/models/3_cushion_couch.glb'
  },
  {
    id: 3,
    name: 'Mid-Century Modern',
    basePrice: 1200,
    description: 'Classic mid-century modern couch design',
    image: 'https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=400',
    modelPath: '/models/couch_-_midcentury_modern.glb'
  },
  {
    id: 4,
    name: 'Cushioned Armchair',
    basePrice: 450,
    description: 'Comfortable cushioned chair for any room',
    image: 'https://images.unsplash.com/photo-1592078615290-033ee584e267?w=400',
    modelPath: '/models/cushioned_chair.glb'
  },
  {
    id: 5,
    name: 'L-Shaped Sectional',
    basePrice: 1500,
    description: 'Gray L-shaped couch perfect for large spaces',
    image: 'https://images.unsplash.com/photo-1582582621959-48d27397dc69?w=400',
    modelPath: '/models/gray_l-shaped_couch.glb'
  },
  {
    id: 6,
    name: 'Modern Sofa',
    basePrice: 1100,
    description: 'Sleek and modern sofa with clean lines',
    image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400',
    modelPath: '/models/modern__sofa.glb'
  },
  
];

export const fabrics = [
  { id: 1, name: 'Cotton', price: 0 },
  { id: 2, name: 'Leather', price: 100 },
  { id: 3, name: 'Velvet', price: 75 },
  { id: 4, name: 'Linen', price: 25 },
  { id: 5, name: 'Wool', price: 50 }
];

export const colors = [
  { id: 1, name: 'Black', value: '#000000', price: 0 },
  { id: 2, name: 'White', value: '#FFFFFF', price: 0 },
  { id: 3, name: 'Navy Blue', value: '#000080', price: 20 },
  { id: 4, name: 'Burgundy', value: '#800020', price: 25 },
  { id: 5, name: 'Forest Green', value: '#228B22', price: 15 },
  { id: 6, name: 'Charcoal Gray', value: '#36454F', price: 10 },
  { id: 7, name: 'Cream', value: '#F5F5DC', price: 15 },
  { id: 8, name: 'Chocolate Brown', value: '#7B3F00', price: 10 }
];